import { IMAGE_LIBRARY_TYPE } from "@/shared/imageLibrary/types";
import useBranchId from "@/shared/hooks/useBranchId";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getMenuImageUrl } from "../../shared/utils/helpers";
import { Col } from "react-grid-system";
import File from "../Base/File";
import Textfield from "../Input/Textfield";
import TextfieldIntControlled from "../Input/TextfieldIntControlled";
import Select from "../Select/Select";
import { MenuDataTagKind, Topping } from "@/shared/utils/interfaces";
import MenuDataTagFields from "./MenuDataTagFields";
import { Row } from "react-grid-system";
import useVatHook from "@/shared/hooks/useVatHook";
import { productStatus } from "@/shared/utils/constant";
import { ProductStatusEnums } from "@/shared/utils/enum";

interface Props {
  defaultValue: Topping;
  isShown: boolean;
}

const ToppingModalStandard = ({ defaultValue, isShown }: Props) => {
  const { t } = useTranslation();
  const formContext = useFormContext();
  const { errors, register, control } = formContext;
  const branchId = useBranchId();
  const { vats } = useVatHook();

  return (
    <Row style={{ display: isShown ? "flex" : "none", rowGap: "1.5rem",}}>
      <Col xs={12} md={6}>
        <TextfieldIntControlled
          label={t("toppings.name")}
          placeholder={t("enterValue")}
          name="name"
          defaultValue={defaultValue?.name || {}}
          validationMessage={t("standardMustBeFilled")}
          required
        />
      </Col>
      <Col xs={12} md={6}>
        <TextfieldIntControlled
          label={t("toppings.description")}
          placeholder={t("enterValue")}
          name="description"
          defaultValue={defaultValue?.description || {}}
        />
      </Col>
      <Col xs={12} md={6}>
        <Textfield
          defaultValue={defaultValue?.price}
          name="price"
          type="number"
          step=".01"
          error={errors?.price?.message}
          ref={register({
            required: true,
          })}
          label={t("toppings.price")}
          placeholder={t("enterValue")}
        />
      </Col>
      <Col xs={12} md={6}>
        <Controller
          name="vat_enum"
          control={control}
          defaultValue={defaultValue?.vat_enum ?? vats[1].id}
          render={(props) => {
            return (
              <Select
                label={t("vat")}
                menuPortalTarget={document.getElementById("root")}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 1000000 }),
                }}
                onChange={(v) => props.onChange(v.id)}
                value={vats.find((option) => option.id === props.value)}
                options={vats}
                getOptionLabel={(option) => t(option.label)}
                getOptionValue={(option) => option.id}
              />
            );
          }}
        />
      </Col>
      <Col xs={12} md={6}>
        <Controller
          name="status_enum"
          control={control}
          defaultValue={defaultValue?.status_enum ?? ProductStatusEnums.AVAILABLE}
          render={(props) => {
            return (
              <Select
                label={t("status")}
                placeholder={t("status")}
                menuPortalTarget={document.getElementById("root")}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 1000000 }),
                }}
                onChange={(v) => props.onChange(v.value)}
                value={productStatus.find(
                  (option) => option.value === props.value
                )}
                options={productStatus}
                getOptionLabel={(option) => t(option.label)}
                getOptionValue={(option) => String(option.value)}
              />
            );
          }}
        />
      </Col>
      <Col xs={12} md={6}>
        <Controller
          name="image_cloudinary_id"
          control={control}
          defaultValue={defaultValue?.image_cloudinary_id}
          render={(props) => {
            return (
              <File
                size="7.5rem"
                onChange={async (data, hasError) => {
                  if (!hasError && data?.[0]) {
                    props.onChange(data?.[0]);
                  }
                }}
                src={getMenuImageUrl(
                  defaultValue?.image_cloudinary_id,
                  branchId,
                  IMAGE_LIBRARY_TYPE.topping
                )}
                // onClickDelete={() =>
                //   setModal("menuConfirmation", {
                //     type: "image",
                //     data: { ...category },
                //   })
                // }
              />
            );
          }}
        />
      </Col>
      <Col xs={12}>
        <MenuDataTagFields
          kind={MenuDataTagKind.TOPPING}
          defaultValue={defaultValue}
          showSize
        />
      </Col>
    </Row>
  );
};

export default ToppingModalStandard;
